/**
 * Нормалізує статус з API у суфікс класу для `.wallet-tx-status-badge--*`
 */
export const getWalletTxStatusModifier = (status) => {
  if (status === 2 || status === "2") return "success";
  if (status === 1 || status === "1") return "pending";
  if (status === 0 || status === "0") return "unverified";

  const s = String(status ?? "")
    .trim()
    .toLowerCase();

  const map = {
    success: "success",
    verified: "success",
    complete: "success",
    completed: "success",
    pending: "pending",
    processing: "pending",
    unverified: "unverified",
    failed: "failed",
    error: "failed",
    cancelled: "cancelled",
    canceled: "cancelled",
    rejected: "rejected",
  };

  return map[s] ?? "default";
};

export const isSuccessfulDepositTransaction = (transaction) =>
  transaction?.operation === "deposit" &&
  getWalletTxStatusModifier(transaction?.status) === "success";
